import React, { Fragment } from 'react';
import IncomeSourceListBrowser from './IncomeSourceListBrowser';
import PropTypes from 'prop-types';
import HeaderPortal from '../../../../components/layout/HeaderPortal';
import HeaderLinks from './HeaderLinks';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import Portal from 'utils/portal/Portal';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_INCOME_SOURCES } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const onAdd = () => {
    historyContext.push(`/incomeSources/new`);
  };

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_INCOME_SOURCES} withForbiddenPage={false}>
          <HeaderLinks onAdd={onAdd} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_INCOME_SOURCES}>
        <IncomeSourceListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
